import { containsEmoji } from '@app/libs/validation';

export const MAX_LENGTH_ERROR = '최대 입력가능한 길이는 30자입니다.';
export const MIN_LENGTH_ERROR = '2자 이상 입력해주세요.';
export const EMOJI_ERROR = '이모지는 사용할 수 없습니다.';
export const SPECIAL_CHARACTER_ERROR = '~ ! @ # $ % ^ & - _ ( ) { } [ ] . 만 입력할 수 있습니다.';

export const whiteListRegexOfNumberEnglishKoreanSpecialCharacter =
  /^[0-9a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣~!@#$%^&\-_(){}[\]. ]*$/g;
function validateName(value: string): string | true {
  const v = value?.trim();

  if (v.length < 2) {
    return MIN_LENGTH_ERROR;
  }
  if (v.length > 30) {
    return MAX_LENGTH_ERROR;
  }
  if (containsEmoji(v)) {
    return EMOJI_ERROR;
  }
  if (!v.match(whiteListRegexOfNumberEnglishKoreanSpecialCharacter)) {
    return SPECIAL_CHARACTER_ERROR;
  }

  return true;
}

export default validateName;
